// app/javascript/components/navbar_app/NavbarWrapper.jsx
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { NavBarApplicationLayout } from '@rankmi/ats-app'; // Tu componente original

// 1. Este es tu componente de Fallback (Funcional)
const NavbarFallback = ({ error }) => {
  // Puedes usar el objeto 'error' para loguear o revisar qué falló
  console.error("Error detectado en el Navbar:", error);

  return (
    <div>
    </div>
  );
};

// 2. El componente principal que exportas a Rails (Funcional)
const NavbarWrapper = (props) => {
  const logErrorToService = () => {
    // Opcional: Aquí puedes enviar el error a Sentry, Bugsnag, etc.
    window.location.reload();
  };

  return (
    <ErrorBoundary
      FallbackComponent={NavbarFallback}
      onError={logErrorToService}
    >
      <NavBarApplicationLayout {...props} />
    </ErrorBoundary>
  );
};

export default NavbarWrapper;